import React, { useEffect, useMemo, useState } from 'react'
// import { AzureCommunicationTokenCredential, CommunicationUserIdentifier } from '@azure/communication-common';
import { MeetingService } from '../../../service/manage/meetings/meetings.service';
import { useMainContext } from '../../../context/hooks/use-main-context';
import { sweetStatusAlert } from '../../../components/common/SweetAlert';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import AdminTemplate from '../../../components/admin/layouts/Template';
import ContentWrapper from '../../../components/common/ContentWrapper';
import Card from '../../../components/common/Card';
import CardHeader from '../../../components/common/CardHeader'
import CardBody from "../../../components/common/CardBody";
import CardTitle from "../../../components/common/CardTitle";
import MeetingList from './components/meeting-list';
import Button from '@mui/material/Button';
import { CreateMeeting } from './components/create-meeting';

export default function ManageMeetings({state}) {

  const {set_auth_code_graph_api,authorize_code_graph_api} = useMainContext()
  
  const [accessToken, setAccessToken] = useState(null);
  const [message, setMessage] = useState('');
  const [teamsMeetingData, setTeamsMeetingData] = useState(null);

  const [meetingList, setMeetingList] = useState([]);

  const [createModalOpen, setCreateModalOpen] = useState(false);

  const [isLoading, setIsLoading] = useState("initial")
  const [isLoadingProcess, setIsLoadingProcess] = useState(false)

  const [users, setUsers] = useState([])
  const [usersLoading, setUsersLoading] = useState(false)

  const [privilegeAdd, setPrivilegeAdd] = useState(state?.privilege_add)
  const [privilegeEdit, setPrivilegeEdit] = useState(state?.privilege_edit)
  const [privilegeView, setPrivilegeView] = useState(false)
  const [privilegeDelete, setPrivilegeDelete] = useState(false)


  useEffect(() => {
    setAccessToken(authorize_code_graph_api)
  }, [authorize_code_graph_api])

  useEffect(() => {

    if(state.mid){
      getTeamsMeetingByNodeMid()
    }
    
  }, [state.mid])
  
  useEffect(() => {
    
    if(teamsMeetingData){
      addTeamsEvent(teamsMeetingData)
    }

  }, [teamsMeetingData])
  
  
  const authoriseAccess = async()=>{

    try {

      const redirectPath = window.location.origin + window.location.pathname
      const token = await MeetingService.getAuthorization(redirectPath)
      set_auth_code_graph_api(token);
      setAccessToken(token);
      
    } catch (error) {
      sweetStatusAlert("Failed","Failed to get premission","info")
    }
    
  }

  const getTeamsMeetingByNodeMid = async()=>{

    try {

      const response = await MeetingService.getTeamsEventByNodeMid(state.mid)

      if(response.success){
        setMeetingList(response.data)
      }
      
    } catch (error) {
      console.error(error);
      
    }

  }

  const createTeamsMeeting = async (payload) => {

    if (!accessToken) {
      sweetStatusAlert("Missing", "Graph Access Token is not available", "warning");
      return;
    }
    if(!payload){
      sweetStatusAlert("Missing", "Payload is not available", "warning");
      return;
    }

    setMessage("Creating Teams meeting...");
    try {
      const meeting = await MeetingService.createTeamsMeeting(accessToken,payload);
      setTeamsMeetingData(meeting);
      setIsLoading("loaded")
      onCloseDrawer()
      
    } catch (err) {
      sweetStatusAlert("Error", "Meeting creation failed", "error");
      setIsLoading("initial")
    } finally {
      setMessage('');
      setIsLoading("initial")
    }
  };

  const addTeamsEvent = async(teamsMeetingData) =>{

    setIsLoadingProcess(true)
    const meetingData = {
      joinurl: teamsMeetingData.onlineMeeting.joinUrl,
      graphmeetingid:teamsMeetingData.id,
      startdatetime: teamsMeetingData.start.dateTime,
      enddatetime:  teamsMeetingData.end.dateTime,
      timezone: teamsMeetingData.end.timeZone || teamsMeetingData.start.timeZone,
      subject: teamsMeetingData.subject,
      node_mid: state.mid,
      create_user_id: state.lg_user_id,
      create_user_table_id: state.lg_user_table_id
    }

    try {

      const result = await MeetingService.addTeamsEvent(meetingData)

      if(result.success){
        setIsLoadingProcess(false)
        sweetStatusAlert("Success", "Meeting Created", "success");
        setIsLoading("initial")
        await getTeamsMeetingByNodeMid()
      }
      else if(result.success === false){
        setIsLoadingProcess(false)
        sweetStatusAlert("Warning", "Meeting created and failed to save", "info");
        setIsLoading("initial")
      }
      
      
    } catch (error) {
      console.error(error);
      sweetStatusAlert("Error", "Meeting creation failed", "error");
      setIsLoading("initial")
      setIsLoadingProcess(false)
      
    }

  }

  const createMeeting = async(payload) =>{
    
    await createTeamsMeeting(payload)
    
  }

  const getUsersList = async()=>{

    try {
      setUsersLoading(true)
      const {mid, lg_user_id, lg_user_table_id}= state;

      const result = await MeetingService.getMembersListOfNode(mid, lg_user_id,lg_user_table_id)
      const members = JSON.parse(result.data.members)
      
      setUsers(members)
      setUsersLoading(false)
    } catch (error) {
      setUsersLoading(false)
      console.error(error);
      
    }

  }

  const onCloseDrawer = ()=>{setCreateModalOpen(false)};

  const setOpenDrawer = async()=>{
    setCreateModalOpen(true)
    await getUsersList();
  };

  
  return (
    <div>

        <ContentWrapper>

          <Card>

            <CardBody>

              <Backdrop
                  sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                  open={isLoadingProcess}
                >
                  <CircularProgress color="inherit" />
              </Backdrop>
              {privilegeAdd  &&
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                {!accessToken &&
                <Button sx={{backgroundColor:"mediumpurple"}} variant='filled' color='primary' onClick={authoriseAccess}>Click to Authorize Access</Button>
                }

                {accessToken  &&
                <>
                  <Button sx={{backgroundColor:"lightskyblue"}} variant='filled' color='success' onClick={setOpenDrawer}>
                    Schedule Meeting
                  </Button>
                  
                  </>
                }

                <MeetingList meetingList={meetingList}/>
                 
              </Box>
              }
            </CardBody>
          </Card>

          {createModalOpen && accessToken &&
            <CreateMeeting 
              open={createModalOpen} 
              onClose={onCloseDrawer} 
              setOpen={setOpenDrawer} 
              createMeeting={createMeeting} 
              accessToken={accessToken} 
              isLoading={isLoading} 
              setIsLoading={setIsLoading}
              users={users}
              usersLoading={usersLoading}
            />
          }
        </ContentWrapper>
  </div>
  )
}